import { Injectable } from '@angular/core';
import { List as ImmutableList } from 'immutable';
import { ReferencePatternServer } from '../core-data-model/Guidebook.interface';
import { RefProfileReportInfo } from '../core-data-model/Job/JobReportInfo.model';
import {
    ReferencePatternType,
    ReferencePatternsInformation
} from '../core-data-model/ReferencePatternType.model';

@Injectable({
    providedIn: 'root'
})
export class ToolboxTransformer {
    transformReferenceProfiles(
        resultJson: ReferencePatternServer[]
    ): RefProfileReportInfo[] {
        const patternMatches: RefProfileReportInfo[] = [];
        if (resultJson) {
            patternMatches.push(
                ...resultJson.map((item) => this.transformToRefProfile(item))
            );
        }
        return patternMatches;
    }

    transformToRefProfile(
        matchProfile: ReferencePatternServer
    ): RefProfileReportInfo {
        return new RefProfileReportInfo({
            badgeUrl: matchProfile.badgeUrl,
            challenges: ImmutableList(matchProfile.challenges),
            description: matchProfile.description,
            moreInfoLink: matchProfile.moreInfoLink,
            name: matchProfile.name,
            patternNumber: matchProfile.patternNumber,
            pluralName: matchProfile.pluralName,
            singularName: matchProfile.singularName,
            traits: ImmutableList(matchProfile.traits),
            jobBadgeUrl: matchProfile.jobBadgeUrl
        });
    }

    transformReferencePatterns(
        resultJson: ReferencePatternServer[]
    ): ReferencePatternType[] {
        const patternMatches: ReferencePatternType[] = [];
        if (resultJson) {
            patternMatches.push(
                ...resultJson.map((item) => this.transformToRefPattern(item))
            );
        }
        return patternMatches;
    }

    transformToRefPattern(
        matchProfile: ReferencePatternServer
    ): ReferencePatternType {
        return ReferencePatternsInformation.find(
            (profile) => profile.id === matchProfile.patternNumber
        );
    }
}
